import $ from 'jquery';

/**
 * 
 * Image Map element related functions
 * 
 */

const ImageMap = (() => {

    const EL_SELECTOR = ".area-map";

    const initialize = () => {

        const $imagemapElements = $(EL_SELECTOR);

        if ($imagemapElements.length) {
            
            
            $imagemapElements.each((idx, el) => {
                const $el = $(el);

                //get ell hotspots
                const $hotspots = $el.find('.image-hotspot')
                $hotspots.each((idx, hotspot) => {
                    let $hotspot = $(hotspot);
                    
                    // handle only image maps that are not backed by foundation tooltips
                    console.debug($hotspot.data('tooltip'));
                    if ($hotspot.data('tooltip') === undefined)  {
                        // if the hotspot does not have a tooltip, add a click handler 
                        // needed for touch devices
                        $hotspot.on('click', (e) => {
                            // reset visibility of all hotspots
                            $hotspots.removeClass('is-visible');
                            $hotspot.addClass('is-visible');
                        });
                        // close on blur event
                        $hotspot.on('blur', (e) => {
                            // reset visibility of all hotspots
                            $hotspot.toggleClass('is-visible');
                        });
                    }
                });
                
            });
        }
    };

    return {
        init: initialize
    }

})($);

export default ImageMap;